(function () {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || !window.ProductVariants) return;

  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.getElementById("ProductPrice");
  var submitBtn = form.querySelector('[type="submit"][name="add"]');
  var optionSelects = form.querySelectorAll('select[name^="options"]');

  function selectedOptions() {
    return Array.prototype.map.call(optionSelects, function (select) {
      return select.value;
    });
  }

  function findVariant(options) {
    return window.ProductVariants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return opt === options[i];
      });
    });
  }

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: "currency",
        currency: window.ShopifyCurrency || "AUD"
      });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function sync() {
    if (!optionSelects.length) return;
    var variant = findVariant(selectedOptions());
    if (!variant) {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Unavailable";
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? "Add to cart" : "Sold out";
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener("change", sync);
  });

  sync();
})();
